import { api } from "../../api/client";

export function login(credentials) {
  return api.post("/admin/login", credentials);
}

export function logout(username, sessionId) {
  return api.post("/admin/logout", { username, session_id: sessionId });
}
